// ============================================================================
//  Programa: Domino mis cuentas
//  Encuestas: "pre" (form 5218292) y "post" (form 5218294).
//  Versión Junior fija: no se pregunta la versión, se envía siempre.
// ============================================================================
import { validarCedula, validarEmail, validarFecha } from "./validaciones";

const DEFAULTS_PRE = {
  tfa_5151: "tfa_5163", // Versión Junior
  tfa_5000: "tfa_5001", // ¿Estás estudiando? → Sí, curso la escuela secundaria
  tfa_5008: "tfa_5012", // Máximo nivel educativo → Secundaria completa
};

const STEPS_PRE = [
  { id: "tfa_1877", label: "¡Hola! Para empezar, ¿cuál es tu nombre?", type: "text", placeholder: "Tu nombre" },
  { id: "tfa_1875", label: "¿Y tu apellido?", type: "text", placeholder: "Tu apellido" },
  { id: "tfa_4953", label: "¿Con qué género te identificás?", type: "radio", options: [
    { val: "tfa_4954", label: "Femenino" }, { val: "tfa_4955", label: "Masculino" }, { val: "tfa_4956", label: "No binario" },
  ]},
    { id: "tfa_4961", label: "¿Cuál es tu fecha de nacimiento? (DD/MM/AAAA)", type: "text", placeholder: "Ej: 15/06/2001", validate: validarFecha },
  { id: "tfa_1", label: "¿Cuál es tu cédula o documento de identidad?", type: "text", placeholder: "Tu número de documento", validate: validarCedula },
  { id: "tfa_4963", label: "¿Cuál es tu correo electrónico?", type: "text", placeholder: "tu@email.com", validate: validarEmail },
  { id: "tfa_4965", label: "¿Cuál es tu número de celular?", type: "text", placeholder: "Ej: 099123456" },
  { id: "tfa_4990", label: "¿En qué ciudad vivís?", type: "text", placeholder: "Ej: Montevideo" },
  { id: "tfa_5217", label: "Antes de los 18 años, ¿tenés/tuviste responsabilidades como cuidar familiares, trabajar o hacer tareas del hogar de manera regular?", type: "radio", options: [
    { val: "tfa_5218", label: "Sí, de manera regular" }, { val: "tfa_5219", label: "Sí, ocasionalmente" },
    { val: "tfa_5220", label: "No" }, { val: "tfa_5221", label: "Prefiero no responder" },
  ]},
  { id: "tfa_5227", label: "¿Cuál describe mejor la situación laboral de tus padres o cuidadores durante tu crecimiento?", type: "radio", options: [
    { val: "tfa_5228", label: "Profesiones, cargos gerenciales o directivos" },
    { val: "tfa_5229", label: "Trabajo calificado o técnico" },
    { val: "tfa_5230", label: "Trabajo en servicios, comercio o tareas manuales" },
    { val: "tfa_5231", label: "Trabajo independiente o pequeño negocio" },
    { val: "tfa_5232", label: "Trabajo rural o informal" },
    { val: "tfa_5233", label: "Empleo no constante" },
    { val: "tfa_5234", label: "No lo sé" }, { val: "tfa_5235", label: "Prefiero no responder" },
  ]},
  { id: "tfa_5241", label: "Antes de los 18 años, ¿contribuiste regularmente con dinero para el sostenimiento de tu hogar?", type: "radio", options: [
    { val: "tfa_5242", label: "Sí" }, { val: "tfa_5243", label: "No" },
    { val: "tfa_5244", label: "No lo sé" }, { val: "tfa_5245", label: "Prefiero no responder" },
  ]},
  { id: "tfa_4994", label: "¿Es la primera vez que participás en un programa de Junior Achievement?", type: "radio", options: [
    { val: "tfa_4995", label: "Sí, es la primera vez" },
    { val: "tfa_4996", label: "No, participé en otros programas" },
  ]},

  // — Sección evaluación —
  { id: "tfa_5017", label: "¿Qué es un presupuesto?", type: "radio", options: [
    { val: "tfa_5018", label: "Una suposición básica" },
    { val: "tfa_5019", label: "Una herramienta que ayuda a administrar el dinero" },
    { val: "tfa_5020", label: "Algo creado por un experto en economía" },
    { val: "tfa_5021", label: "La ganancia que queda después de vender un producto" },
    { val: "tfa_5022", label: "No lo sé" },
  ]},
  { id: "tfa_5029", label: "¿Cuándo fue la última vez que realizaste un presupuesto?", type: "radio", options: [
    { val: "tfa_5030", label: "No tengo un presupuesto" }, { val: "tfa_5031", label: "Esta semana" },
    { val: "tfa_5032", label: "La semana pasada" }, { val: "tfa_5033", label: "Hace dos semanas" },
    { val: "tfa_5247", label: "El mes pasado" }, { val: "tfa_5248", label: "Hace tres meses" },
    { val: "tfa_5249", label: "Hace seis meses" }, { val: "tfa_5250", label: "El año pasado" },
  ]},
  { id: "tfa_5039", label: "¿Cuándo es conveniente realizar un presupuesto?", type: "radio", options: [
    { val: "tfa_5040", label: "Al inicio del año" },
    { val: "tfa_5041", label: "Cuando tus egresos sean mayores a tus ingresos" },
    { val: "tfa_5043", label: "Cuando tenés dinero para administrar" },
    { val: "tfa_5044", label: "No lo sé" },
  ]},
  { id: "tfa_5051", label: "¿Qué es el ahorro?", type: "radio", options: [
    { val: "tfa_5052", label: "Guardar el dinero que sobra" },
    { val: "tfa_5053", label: "Separar una cantidad de dinero de tu ingreso para un objetivo futuro" },
    { val: "tfa_5054", label: "Dinero que recibís sin intereses" },
    { val: "tfa_5055", label: "El dinero que recibís si invertís bien" },
    { val: "tfa_5056", label: "No lo sé" },
  ]},
  { id: "tfa_5063", label: "En los últimos 6 meses, ¿con qué regularidad ahorraste una parte de tus ingresos?", type: "radio", options: [
    { val: "tfa_5064", label: "Siempre ahorro una parte de cada pago" },
    { val: "tfa_5065", label: "Generalmente ahorro, aunque a veces no" },
    { val: "tfa_5066", label: "Ocasionalmente, cuando tengo dinero extra" },
    { val: "tfa_5067", label: "Actualmente no ahorro ninguna parte" },
  ]},
  { id: "tfa_5073", label: "¿Qué tan seguro/a te sentís sobre tu capacidad para tomar decisiones financieras informadas?", type: "radio", options: [
    { val: "tfa_5074", label: "Nada segura/o" }, { val: "tfa_5075", label: "Poco segura/o" },
    { val: "tfa_5076", label: "Moderadamente segura/o" }, { val: "tfa_5077", label: "Muy segura/o" },
    { val: "tfa_5251", label: "Extremadamente segura/o" },
  ]},
  { id: "tfa_5258", label: "¿Cuál de estas acciones realizás actualmente para administrar tu dinero?", type: "radio", options: [
    { val: "tfa_5259", label: "Registrar gastos y/o ingresos" },
    { val: "tfa_5260", label: "Planificar cómo usar el dinero en la semana o el mes" },
    { val: "tfa_5261", label: "Apartar dinero para necesidades futuras (ahorro)" },
    { val: "tfa_5262", label: "Priorizar gastos según necesidades y deseos" },
    { val: "tfa_5263", label: "Comparar opciones antes de tomar decisiones financieras" },
    { val: "tfa_5264", label: "Ninguna de las anteriores" },
  ]},
  { id: "tfa_1961", label: "Antes de comprar algo, considerás cuidadosamente si podés pagarlo", type: "radio", options: [
    { val: "tfa_4517", label: "Muy en desacuerdo" }, { val: "tfa_4518", label: "En desacuerdo" },
    { val: "tfa_4519", label: "Ni de acuerdo ni en desacuerdo" },
    { val: "tfa_4631", label: "De acuerdo" }, { val: "tfa_4632", label: "Muy de acuerdo" },
  ]},
  { id: "tfa_5085", label: "Sigo de cerca mis temas financieros", type: "radio", options: [
    { val: "tfa_5086", label: "Muy en desacuerdo" }, { val: "tfa_5087", label: "En desacuerdo" },
    { val: "tfa_5088", label: "Ni de acuerdo ni en desacuerdo" },
    { val: "tfa_5089", label: "De acuerdo" }, { val: "tfa_5090", label: "Muy de acuerdo" },
  ]},
  { id: "tfa_5097", label: "No tiendo a preocuparme sobre si podré pagar mis gastos cotidianos", type: "radio", options: [
    { val: "tfa_5098", label: "Muy en desacuerdo" }, { val: "tfa_5099", label: "En desacuerdo" },
    { val: "tfa_5100", label: "Ni de acuerdo ni en desacuerdo" },
    { val: "tfa_5101", label: "De acuerdo" }, { val: "tfa_5102", label: "Muy de acuerdo" },
  ]},
  { id: "tfa_4812", label: "Imaginá que tu teléfono está viejo y querés cambiarlo. ¿Cuál sería la mejor opción?", type: "radio", options: [
    { val: "tfa_4818", label: "Comprar con tarjeta de crédito y pagarlo más tarde" },
    { val: "tfa_4819", label: "Pedir un préstamo para uno de última tecnología" },
    { val: "tfa_4820", label: "Vender algún electrodoméstico para comprar otro" },
    { val: "tfa_4821", label: "Jugar a la lotería para ganar dinero" },
    { val: "tfa_4822", label: "Establecer una meta de ahorro mensual para comprarlo en unos meses" },
    { val: "tfa_5265", label: "No lo sé" },
  ]},
  { id: "tfa_5109", label: "Si querés empezar a invertir, tenés que pensar en:", type: "radio", options: [
    { val: "tfa_5110", label: "Los productos que estén dando más ganancias" },
    { val: "tfa_5111", label: "Cuáles son los productos que la gente usa más" },
    { val: "tfa_5112", label: "Definir qué relación quiero entre riesgo y ganancia" },
    { val: "tfa_5266", label: "No lo sé" },
  ]},
  { id: "tfa_5117", label: "¿Para qué sirven los seguros?", type: "radio", options: [
    { val: "tfa_5118", label: "Proteger nuestros bienes" },
    { val: "tfa_5119", label: "Recuperar el costo total en caso de pérdida" },
    { val: "tfa_5120", label: "Proteger nuestra salud y la de nuestra familia" },
    { val: "tfa_5121", label: "Cubrir los daños ocasionados a terceros" },
    { val: "tfa_5122", label: "Tener asistencia durante un viaje" },
    { val: "tfa_5123", label: "Todas las opciones son correctas" },
    { val: "tfa_5267", label: "No lo sé" },
  ]},
  { id: "tfa_5131", label: "¿Cuál es una característica propia del crédito informal?", type: "radio", options: [
    { val: "tfa_5132", label: "Permite generar un historial crediticio" },
    { val: "tfa_5133", label: "Contás con protección de algún organismo público" },
    { val: "tfa_5134", label: "Tasas de intereses excesivamente altas" },
    { val: "tfa_5135", label: "En algunos casos cuentan con recompensas" },
    { val: "tfa_5136", label: "Es necesario realizar un trámite para solicitarlo" },
    { val: "tfa_5268", label: "No lo sé" },
  ]},
];

const DEFAULTS_POST = {
  tfa_5271: "tfa_5272", // Versión Junior Domino mis cuentas
};

const ACUERDO_POST = (a, b, c, d, e) => [
  { val: a, label: "Muy en desacuerdo" },
  { val: b, label: "En desacuerdo" },
  { val: c, label: "Ni de acuerdo ni en desacuerdo" },
  { val: d, label: "De acuerdo" },
  { val: e, label: "Muy de acuerdo" },
];

const CALIF_POST = (a, b, c, d, e) => [
  { val: a, label: "Muy mala" },
  { val: b, label: "Mala" },
  { val: c, label: "Ni mala ni buena" },
  { val: d, label: "Buena" },
  { val: e, label: "Muy buena" },
];

const STEPS_POST = [
  // — Datos —
  { id: "tfa_1877", label: "¡Hola! Para empezar, ¿cuál es tu nombre?", type: "text", placeholder: "Tu nombre" },
  { id: "tfa_1875", label: "¿Y tu apellido?", type: "text", placeholder: "Tu apellido" },
    { id: "tfa_1", label: "¿Cuál es tu cédula o documento de identidad?", type: "text", placeholder: "Tu número de documento", validate: validarCedula },
  { id: "tfa_4963", label: "¿Cuál es tu correo electrónico? (el mismo que usaste en el cuestionario anterior)", type: "text", placeholder: "tu@email.com", validate: validarEmail },
  { id: "tfa_4965", label: "¿Cuál es tu número de celular? (el mismo que usaste en el cuestionario anterior)", type: "text", placeholder: "Ej: 099123456" },

  // — Evaluación —
  { id: "tfa_5017", label: "¿Qué es un presupuesto?", type: "radio", options: [
    { val: "tfa_5018", label: "Una suposición básica" },
    { val: "tfa_5019", label: "Una herramienta que ayuda a administrar el dinero" },
    { val: "tfa_5020", label: "Algo creado por un experto en economía" },
    { val: "tfa_5021", label: "La ganancia que queda después de vender un producto" },
    { val: "tfa_5022", label: "No lo sé" },
  ]},
  { id: "tfa_5029", label: "¿Cuándo fue la última vez que realizaste un presupuesto?", type: "radio", options: [
    { val: "tfa_5030", label: "No tengo un presupuesto" }, { val: "tfa_5031", label: "Esta semana" },
    { val: "tfa_5032", label: "La semana pasada" }, { val: "tfa_5033", label: "Hace dos semanas" },
    { val: "tfa_5334", label: "El mes pasado" }, { val: "tfa_5335", label: "Hace tres meses" },
    { val: "tfa_5336", label: "Hace seis meses" }, { val: "tfa_5337", label: "El año pasado" },
  ]},
  { id: "tfa_5039", label: "¿Cuándo es conveniente realizar un presupuesto?", type: "radio", options: [
    { val: "tfa_5040", label: "Al inicio del año" },
    { val: "tfa_5041", label: "Cuando tus egresos sean mayores a tus ingresos" },
    { val: "tfa_5043", label: "Cuando tenés dinero para administrar" },
    { val: "tfa_5044", label: "No lo sé" },
  ]},
  { id: "tfa_5051", label: "¿Qué es el ahorro?", type: "radio", options: [
    { val: "tfa_5052", label: "Guardar el dinero que sobra" },
    { val: "tfa_5053", label: "Separar una cantidad de dinero de tu ingreso para un objetivo futuro" },
    { val: "tfa_5054", label: "Dinero que recibís sin intereses" },
    { val: "tfa_5055", label: "El dinero que recibís si invertís bien" },
    { val: "tfa_5056", label: "No lo sé" },
  ]},
  { id: "tfa_5063", label: "En los últimos 6 meses, ¿con qué regularidad ahorraste una parte de tus ingresos?", type: "radio", options: [
    { val: "tfa_5064", label: "Siempre ahorro una parte de cada pago que recibo" },
    { val: "tfa_5065", label: "Generalmente ahorro, aunque a veces no lo hago todos los meses" },
    { val: "tfa_5066", label: "Ocasionalmente, cuando tengo dinero extra" },
    { val: "tfa_5067", label: "Actualmente no ahorro ninguna parte de mis ingresos" },
  ]},
  { id: "tfa_5073", label: "¿Qué tan seguro/a te sentís sobre tu capacidad para tomar decisiones informadas sobre la administración de tu dinero?", type: "radio", options: [
    { val: "tfa_5074", label: "Nada segura/o" }, { val: "tfa_5075", label: "Poco segura/o" },
    { val: "tfa_5076", label: "Moderadamente segura/o" }, { val: "tfa_5077", label: "Muy segura/o" },
    { val: "tfa_5338", label: "Extremadamente segura/o" },
  ]},
  { id: "tfa_5344", label: "¿Cuál de las siguientes acciones realizás actualmente para administrar tu dinero?", type: "radio", options: [
    { val: "tfa_5345", label: "Registrar gastos y/o ingresos" },
    { val: "tfa_5346", label: "Planificar cómo utilizar el dinero durante la semana o el mes" },
    { val: "tfa_5347", label: "Apartar dinero para necesidades futuras (ahorro)" },
    { val: "tfa_5348", label: "Priorizar los gastos según necesidades y deseos" },
    { val: "tfa_5349", label: "Comparar opciones o buscar información antes de tomar decisiones financieras" },
    { val: "tfa_5350", label: "Ninguna de las anteriores" },
  ]},

  // — Escalas de acuerdo —
  { id: "tfa_1961", label: "Antes de comprar algo considero cuidadosamente si puedo pagarlo", type: "radio",
    options: ACUERDO_POST("tfa_4517", "tfa_4518", "tfa_4519", "tfa_4631", "tfa_4632") },
  { id: "tfa_5280", label: "Pago mis cuentas a tiempo", type: "radio",
    options: ACUERDO_POST("tfa_5281", "tfa_5282", "tfa_5283", "tfa_5284", "tfa_5285") },
  { id: "tfa_5085", label: "Sigo de cerca mis temas financieros", type: "radio",
    options: ACUERDO_POST("tfa_5086", "tfa_5087", "tfa_5088", "tfa_5089", "tfa_5090") },
  { id: "tfa_5097", label: "No tiendo a preocuparme sobre si podré pagar mis gastos cotidianos", type: "radio",
    options: ACUERDO_POST("tfa_5098", "tfa_5099", "tfa_5100", "tfa_5101", "tfa_5102") },
  { id: "tfa_5292", label: "Estoy satisfecha/o con mi situación financiera actual", type: "radio",
    options: ACUERDO_POST("tfa_5293", "tfa_5294", "tfa_5295", "tfa_5296", "tfa_5297") },
  { id: "tfa_5304", label: "Establezco metas financieras a largo plazo y me esfuerzo por lograrlas", type: "radio",
    options: ACUERDO_POST("tfa_5305", "tfa_5306", "tfa_5307", "tfa_5308", "tfa_5309") },
  { id: "tfa_5316", label: "Me siento segura/o acerca de mi futuro financiero", type: "radio",
    options: ACUERDO_POST("tfa_5317", "tfa_5318", "tfa_5319", "tfa_5320", "tfa_5321") },
  { id: "tfa_5328", label: "Me siento protegida/o ante eventualidades que pueden surgir", type: "radio",
    options: ACUERDO_POST("tfa_5329", "tfa_5330", "tfa_5331", "tfa_5332", "tfa_5333") },

  // — Conocimientos —
  { id: "tfa_4812", label: "Imaginá que tu teléfono está un poco viejo y querés cambiarlo por uno más nuevo. ¿Cuál sería la mejor opción?", type: "radio", options: [
    { val: "tfa_4818", label: "Comprar el celular con tarjeta de crédito y pagarlo más tarde" },
    { val: "tfa_4819", label: "Pedir un préstamo para comprar un teléfono de última tecnología" },
    { val: "tfa_4822", label: "Colocar la meta de ahorro mensual para reunir el dinero y comprarlo en unos meses" },
    { val: "tfa_4820", label: "Vender algún electrodoméstico para comprar otro teléfono" },
    { val: "tfa_4821", label: "Jugar a la lotería para ganar dinero para el teléfono" },
    { val: "tfa_5352", label: "No lo sé" },
  ]},
  { id: "tfa_5109", label: "Si quiero empezar a invertir, tengo que pensar en:", type: "radio", options: [
    { val: "tfa_5110", label: "Los productos que estén dando más ganancias" },
    { val: "tfa_5111", label: "Cuáles son los productos que la gente usa más para invertir" },
    { val: "tfa_5112", label: "Definir qué relación considero óptima entre los riesgos que quiero asumir y las ganancias que espero obtener" },
    { val: "tfa_5351", label: "No lo sé" },
  ]},
  { id: "tfa_5117", label: "¿Para qué sirven los seguros?", type: "radio", options: [
    { val: "tfa_5118", label: "Proteger nuestros bienes" },
    { val: "tfa_5119", label: "Recuperar el costo total en caso de pérdida" },
    { val: "tfa_5120", label: "Proteger a nuestra salud y la de nuestra familia" },
    { val: "tfa_5121", label: "Cubrir los daños ocasionados a terceros" },
    { val: "tfa_5122", label: "Tener asistencia durante un viaje" },
    { val: "tfa_5123", label: "Todas las opciones son correctas" },
    { val: "tfa_5354", label: "No lo sé" },
  ]},
  { id: "tfa_5131", label: "¿Cuál de las siguientes opciones es una característica propia del crédito informal?", type: "radio", options: [
    { val: "tfa_5132", label: "Permite generar un historial crediticio" },
    { val: "tfa_5133", label: "Cuentas con la protección de algún organismo público en caso de incumplimiento" },
    { val: "tfa_5134", label: "Tasas de intereses excesivamente altas" },
    { val: "tfa_5135", label: "En algunos casos cuentan con recompensas" },
    { val: "tfa_5136", label: "Es necesario realizar un trámite para solicitarlo" },
    { val: "tfa_5355", label: "No lo sé" },
  ]},

  // — Satisfacción con el programa —
  { id: "tfa_5140", label: "¿Cómo calificarías la experiencia de participar en el programa?", type: "radio",
    options: CALIF_POST("tfa_5141", "tfa_5142", "tfa_5143", "tfa_5144", "tfa_5145") },
  { id: "tfa_5152", label: "¿Cómo calificarías las dinámicas y actividades propuestas por el programa?", type: "radio",
    options: CALIF_POST("tfa_5153", "tfa_5154", "tfa_5155", "tfa_5156", "tfa_5157") },
  { id: "tfa_5176", label: "¿Cómo calificarías el apoyo recibido por DESEM?", type: "radio",
    options: CALIF_POST("tfa_5177", "tfa_5178", "tfa_5179", "tfa_5180", "tfa_5181") },
  { id: "tfa_5188", label: "Los contenidos del programa fueron lo que esperaba", type: "radio",
    options: ACUERDO_POST("tfa_5190", "tfa_5191", "tfa_5192", "tfa_5193", "tfa_5194") },
  { id: "tfa_5201", label: "Antes de participar del programa se me brindó información clara sobre en qué consistía y el tiempo de duración", type: "radio",
    options: ACUERDO_POST("tfa_5202", "tfa_5203", "tfa_5204", "tfa_5205", "tfa_5206") },
  { id: "tfa_5213", label: "Durante mi participación en el programa, se me brindó una atención respetuosa y amable", type: "radio",
    options: ACUERDO_POST("tfa_5214", "tfa_5215", "tfa_5216", "tfa_5217", "tfa_5218") },
  { id: "tfa_5225", label: "Al finalizar el programa, reconozco que la organización fue buena", type: "radio",
    options: ACUERDO_POST("tfa_5226", "tfa_5227", "tfa_5228", "tfa_5229", "tfa_5230") },
  { id: "tfa_5362", label: "¿Cómo te resultó la duración de la experiencia?", type: "radio", options: [
    { val: "tfa_5366", label: "Corta" }, { val: "tfa_5367", label: "Adecuada" }, { val: "tfa_5368", label: "Larga" },
  ]},
  { id: "tfa_5237", label: "¿Qué puntaje le darías a tu experiencia global con el curso? (1 = mínimo, 10 = máximo)", type: "radio", options: [
    { val: "tfa_5238", label: "1" }, { val: "tfa_5239", label: "2" }, { val: "tfa_5240", label: "3" },
    { val: "tfa_5241", label: "4" }, { val: "tfa_5242", label: "5" }, { val: "tfa_5243", label: "6" },
    { val: "tfa_5244", label: "7" }, { val: "tfa_5245", label: "8" }, { val: "tfa_5246", label: "9" },
    { val: "tfa_5247", label: "10" },
  ]},
  { id: "tfa_5259", label: "¿Qué tan probable es que recomiendes este programa a un/a amiga/o? (1 = mínimo, 10 = máximo)", type: "radio", options: [
    { val: "tfa_5260", label: "1" }, { val: "tfa_5261", label: "2" }, { val: "tfa_5262", label: "3" },
    { val: "tfa_5263", label: "4" }, { val: "tfa_5264", label: "5" }, { val: "tfa_5265", label: "6" },
    { val: "tfa_5266", label: "7" }, { val: "tfa_5267", label: "8" }, { val: "tfa_5268", label: "9" },
    { val: "tfa_5269", label: "10" },
  ]},

  // — Abiertas —
  { id: "tfa_5380", label: "¿Cuáles son los aprendizajes que rescatás del programa?", type: "text", placeholder: "Contanos con tus palabras..." },
  { id: "tfa_5382", label: 'Si tuvieras que contarle a una persona "después del programa voy a...", ¿qué le comentarías?', type: "text", placeholder: "Después del programa voy a..." },
];

const domino = {
  label: "Domino mis cuentas",
  tipos: {
    pre: {
      formId: "5218292",
      titulo: "Evaluación",
      subtitulo: "Evaluación pre programa",
      saludo: "¡Hola! Voy a ayudarte a completar la evaluación pre programa. ¡Empecemos!",
      cierre: "¡Perfecto! Respondiste todas las preguntas. Hacé clic en el botón para enviar tu evaluación.",
      exito: "Gracias por completar la evaluación. ¡Buen viaje de aprendizaje!",
      defaults: DEFAULTS_PRE,
      steps: STEPS_PRE,
    },
    post: {
      formId: "5218294",
      titulo: "Evaluación",
      subtitulo: "Evaluación post programa",
      saludo: "¡Hola! Voy a ayudarte a completar la evaluación post programa. ¡Empecemos!",
      cierre: "¡Perfecto! Respondiste todas las preguntas. Hacé clic en el botón para enviar tu evaluación.",
      exito: "Gracias por completar la evaluación y por haber participado del programa. ¡Felicitaciones!",
      defaults: DEFAULTS_POST,
      steps: STEPS_POST,
    },
  },
};

export default domino;
